import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewRelatedOrganizations from './viewRelatedOrganizations';
import viewRelatedPermissions from './viewRelatedPermissions';
import viewRelatedUserRole from './viewRelatedUserRole';
import viewRelatedUserPermissions from './viewRelatedUserPermissions';
import viewRelatedUsers from './viewRelatedUsers';

export default {
  attributeName: 'users',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  createPath: routes.APP_CONTENT_NEW,
  editURL: routes.USERS_EDIT,
  canRemove: true,
  emptyMessage: "You don't have users, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the organization',
      canEdit: false,
      canCreate: true,
      canFilter:true,
      width: '12rem',
    },
    {
      attributeName: 'email',
      label: 'Email',
      type: FormInputTypes.TEXT_INPUT.EMAIL,
      canEdit: false,
      canCreate: true,
      canFilter:true,
      helpText: 'The users email',
    },
    /*{
      attributeName: 'roles',
      label: 'Role',
      type: FormInputTypes.RELATIONSHIP,
      helpText: 'The users role',
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedUserRole,
    },*/
    {
      attributeName: 'permissions',
      label: 'Permissions',
      type: FormInputTypes.RELATIONSHIP,
      helpText: 'The users permissions',
      canEdit: false,
      canCreate: true,
      configFile: viewRelatedUserPermissions,
    },
    {
      attributeName: 'organization',
      label: 'Organization',
      type: FormInputTypes.RELATIONSHIP,
      helpText: 'The organization the user will belong in',
      canEdit: false,
      canCreate: true,
      configFile: viewRelatedOrganizations,
    },
  ],
};
